var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "float-right" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button" },
          on: { click: _vm.openModal }
        },
        [_c("i", { staticClass: "fa fa-user-cog" })]
      ),
      _vm._v(" "),
      _c("UserAccountsEditModal", { ref: "editModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }